// import { Component, OnInit } from '@angular/core';
// import { BaseComponent } from '../pages/base.component';
// import { ToastrService } from "ngx-toastr";
// import { CommonService } from "src/app/services/common.service";
// import { FileuploadService } from "src/app/services/fileupload.service";
// import { Route, Router } from '@angular/router';
// @Component({
//   selector: 'app-scde-dashboard',
//   templateUrl: './scde-dashboard.component.html',
//   styleUrls: ['./scde-dashboard.component.css']
// })
// export class ScdeDashboardComponent extends BaseComponent implements OnInit {

//   dashboardDetails: any = ""; barChartData: any = []; barChartLabels: any[] = [];
//   subCountyName: any = '';
//   public barChartType: any = "bar";
//   public barChartOptions: any = {
//     responsive: true,
//     scales: {
//       xAxes: [{
//         gridLines: { display: false },
//         scaleLabel: { display: true, labelString: 'Constituencies' }
//       }],
//       yAxes: [{
//         gridLines: { display: true },
//         ticks: { beginAtZero: true },
//         scaleLabel: { display: true, labelString: 'Number of Institutions' }
//       }],
//     },
//   };

//   constructor(
//     protected CommonService: CommonService,
//     protected toastr: ToastrService,
//     private FileuploadService: FileuploadService, private router: Router
//   ) {
//     super(CommonService, toastr);
    
//   }

//   async ngOnInit() {
//     this.LoadDBDitails();
//     const decryptedValue: any = await this.CommonService.decryptAesGcm(
//       localStorage.getItem("RoleId"),
//       this.CommonService.secretKey
//     );
//     this.roleId = decryptedValue;
//   }

//   LoadDBDitails() {
//     const userData = JSON.parse(sessionStorage.getItem("userData"));
//     this.subCountyName = userData?.sub_counties_name;
//     this.dashboardDetails = "";
//     let payLoad = {
//       v_tnt_code: localStorage.getItem("TenantCode"),
//       v_county_id: userData?.county_id,
//       v_sub_county_id: userData?.subcounty_id,
//       v_role_id: localStorage.getItem("RoleId"),
//       v_scde_userid:this.userId,
//       v_schoollevel:localStorage.getItem("schoolLevelID"),
//     };
//     this.CommonService.postCall(`Dashboard/LoadCdeScdeAdminDashboard`, payLoad).subscribe((res: any) => {
//       this.dashboardDetails = res;
//       const list = this.dashboardDetails?.INSTITUTIONS_PER_CONSTITUENCY_IN_SUBCOUNTY || [];
//       // Labels: sub-county names (field named 'reject' in payload)
//       this.barChartLabels = list.map((x: any) => x?.reject ?? "");
//       // Datasets: Total and Pending series
//       this.barChartData = [
//         {
//           label: 'Total',
//           data: list.map((x: any) => +x?.total || 0),
//           backgroundColor: 'rgba(30, 136, 229, 0.6)',
//           borderColor: '#1e88e5',
//           hoverBackgroundColor: 'rgba(30, 136, 229, 0.8)',
//           hoverBorderColor: '#1e88e5'
//         }
//       ];
//     });
//   }

//   navigationUrl() {
//     this.router.navigate([`/HOME/registration/instituteSubmission`]);
//   }
//   navigationTLUrl() {
//     this.router.navigate([`/HOME/reports/learnersRegisteredSubCounty/5137`]);
//   }
//   navgateToSCUrl() {
//     this.router.navigate([`/HOME/courseSetup/subjctCmbntnAprl`]);
//   }
//   navigationISUrl() {
//     this.router.navigate([`/HOME/registration/schoolSubmission/5093`]);
//   }

// }

import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from '../pages/base.component';
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { FileuploadService } from "src/app/services/fileupload.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-scde-dashboard',
  templateUrl: './scde-dashboard.component.html',
  styleUrls: ['./scde-dashboard.component.css']
})
export class ScdeDashboardComponent extends BaseComponent implements OnInit, OnDestroy {

  dashboardDetails: any = ""; 
  barChartData: any = []; 
  barChartLabels: any[] = [];
  subCountyName: any = '';
  private querySubscription: Subscription = new Subscription();
  
  public barChartType: any = "bar";
  public barChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: { display: false },
        scaleLabel: { display: true, labelString: 'Constituencies' }
      }],
      yAxes: [{
        gridLines: { display: true },
        ticks: { beginAtZero: true },
        scaleLabel: { display: true, labelString: 'Number of Institutions' }
      }],
    },
  };

  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private FileuploadService: FileuploadService, 
    private router: Router,
    private active: ActivatedRoute
  ) {
    super(CommonService, toastr);
  }

  async ngOnInit() {
    // Subscribe to query params changes
    this.querySubscription = this.active.queryParams.subscribe((res: any) => {
      // Reload data when cd=true or when school level changes (reload flag)
      if (res.cd == 'true' || res.reload === 'true') {
        this.LoadDBDitails();
      }
    });
    
    await this.LoadDBDitails();
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId"),
      this.CommonService.secretKey
    );
    this.roleId = decryptedValue;
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
  }

  LoadDBDitails() {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    this.subCountyName = userData?.sub_counties_name;
    this.dashboardDetails = "";
    const currentSchoolLevel = localStorage.getItem("schoolLevelID") || "";
    
    let payLoad = {
      v_tnt_code: localStorage.getItem("TenantCode"),
      v_county_id: userData?.county_id,
      v_sub_county_id: userData?.subcounty_id,
      v_role_id: localStorage.getItem("RoleId"),
      v_scde_userid: this.userId,
      v_schoollevel: currentSchoolLevel,
    };
    
    this.CommonService.postCall(`Dashboard/LoadCdeScdeAdminDashboard`, payLoad).subscribe((res: any) => {
      this.dashboardDetails = res;
      const list = this.dashboardDetails?.INSTITUTIONS_PER_CONSTITUENCY_IN_SUBCOUNTY || [];
      // Labels: constituency names
      this.barChartLabels = list.map((x: any) => x?.reject ?? "");
      // Datasets: Total series
      this.barChartData = [
        {
          label: 'Total',
          data: list.map((x: any) => +x?.total || 0),
          backgroundColor: 'rgba(30, 136, 229, 0.6)',
          borderColor: '#1e88e5',
          hoverBackgroundColor: 'rgba(30, 136, 229, 0.8)',
          hoverBorderColor: '#1e88e5'
        }
      ];
    });
  }

  navigationUrl() {
    this.router.navigate([`/HOME/registration/instituteSubmission`]);
  }
  
  navigationTLUrl() {
    this.router.navigate([`/HOME/reports/learnersRegisteredSubCounty/5137`]);
  }
  
  navgateToSCUrl() {
    this.router.navigate([`/HOME/courseSetup/subjctCmbntnAprl`]);
  }
  
  navigationISUrl(id:any) {
    this.router.navigate([`/HOME/registration/schoolSubmission/5093`],{queryParams:{id:id}});
  }
}
